export interface Purchase {
  name: string
  city: string
  country: string
}

export const purchases: Purchase[] = [
  { name: 'Charlotte Baines', city: 'Bristol', country: 'United Kingdom' },
  { name: 'Hannah Whitfield', city: 'Manchester', country: 'United Kingdom' },
  { name: 'Emily Prescott', city: 'Leeds', country: 'United Kingdom' },
  { name: 'Sophie Marsden', city: 'Glasgow', country: 'United Kingdom' },
  { name: 'Melissa Grant', city: 'Calgary', country: 'Canada' },
  { name: 'Rachel Lindqvist', city: 'Toronto', country: 'Canada' },
  { name: 'Amélie Tremblay', city: 'Montreal', country: 'Canada' },
  { name: 'Danielle Okafor', city: 'Austin', country: 'United States' },
  { name: 'Karen Mitchell', city: 'Denver', country: 'United States' },
  { name: 'Jessica Ramirez', city: 'San Diego', country: 'United States' },
  { name: 'Brittany Cole', city: 'Nashville', country: 'United States' },
  { name: 'Sophie Whitcombe', city: 'Melbourne', country: 'Australia' },
  { name: 'Lauren Pike', city: 'Sydney', country: 'Australia' },
  { name: 'Emma Sullivan', city: 'Gold Coast', country: 'Australia' },
  { name: 'Georgia Reid', city: 'Perth', country: 'Australia' },
]
